require("!!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/script-loader/addScript.js")(require("!!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/script-loader/node_modules/raw-loader/index.js!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/site/build/assets/i18n/util/dateformat.fr_FR.js"))


/*****************
 ** WEBPACK FOOTER
 ** ../build/assets/i18n/util/dateformat.fr_FR.js
 ** module id = 4
 ** module chunks = 1 2 3 4 5 6
 **/